import { transitionMotorInsuranceDocumentsForm } from '../../../actions/ugMotorInsurance/Documents';
import { getDocumentsForm } from '../../../selectors/ugMotorInsurance/documents';
import { FIELD_STATUS } from '../../../reducers/status';

export const documentsFormRules = (store, next, action) => {
    const result = next(action);
    const documentsForm = getDocumentsForm(store.getState());
    const documentsFormValid = validateDocumentsFormDetails(documentsForm);
    const formAction = documentsFormValid
        ? transitionMotorInsuranceDocumentsForm.formValid()
        : transitionMotorInsuranceDocumentsForm.formInvalid();
    store.dispatch(formAction);
    return result;
};

const validateDocumentsFormDetails = (formFields) => {
    const gatsbyStack = process.env.GATSBY_COUNTRY_SELECTOR;

    let checks =
        formFields.idUpload &&
        formFields.idUpload.status === FIELD_STATUS.VALID &&
        formFields.logbookUpload &&
        formFields.logbookUpload.status === FIELD_STATUS.VALID;

    if (gatsbyStack === 'ke') {
        return (
            checks && formFields.valuationReportUpload && formFields.valuationReportUpload.status === FIELD_STATUS.VALID
        );
    }

    return (
        checks &&
        formFields.carFrontViewPhoto &&
        formFields.carFrontViewPhoto.status === FIELD_STATUS.VALID &&
        formFields.carBackViewPhoto &&
        formFields.carBackViewPhoto.status === FIELD_STATUS.VALID &&
        formFields.carRightViewPhoto &&
        formFields.carRightViewPhoto.status === FIELD_STATUS.VALID &&
        formFields.carLeftViewPhoto &&
        formFields.carLeftViewPhoto.status === FIELD_STATUS.VALID &&
        formFields.chassisNumberPhoto &&
        formFields.chassisNumberPhoto.status === FIELD_STATUS.VALID &&
        formFields.carDashboardPhoto &&
        formFields.carDashboardPhoto.status === FIELD_STATUS.VALID &&
        formFields.interiorRadioPhoto &&
        formFields.interiorRadioPhoto.status === FIELD_STATUS.VALID &&
        formFields.enginePhoto &&
        formFields.enginePhoto.status === FIELD_STATUS.VALID
    );
};
